import React, { Component } from 'react'

import VideoCardItem from './VideoCardItem'
import CardListHeader from '../../common/list/v1/CardListHeader'
import _ from 'lib/lodash'

import './VideoCardList.css'

class VideoCardList extends Component {
	render() {
		const { actionHandler, aclAllow, title } = this.props;

		// filter nodes with valid storage information
		const nodes = _.pickBy(this.props.nodes, (node, key) => node.hasOwnProperty('storage'));

		// filter for valid storage entries and reverse nodes to have newest on top
		const renderCards = () => _.map(nodes, (node, key) => (
			<VideoCardItem node={node} key={key} actionHandler={actionHandler} aclAllow={aclAllow}/>
		)).reverse();

		return (
			<section>
				<CardListHeader
					nodes={nodes}
					actionHandler={actionHandler}
					title={title}
					titleOne="Video"
					titleMany="Videos"
					aclAllow={aclAllow}
				/>
				<div className="md-list-unstyled video-card-list-items">
					{renderCards()}
				</div>
			</section>
		);
	}
}

export default VideoCardList;



// WEBPACK FOOTER //
// ./src/components/cards/video/v1/VideoCardList.jsx